export const FIRSTNAME_DADATA_ADDITIONAL_DATA = { parts: ['NAME'] };
export const LASTNAME_DADATA_ADDITIONAL_DATA = { parts: ['SURNAME'] };
export const PATRONYMIC_DADATA_ADDITIONAL_DATA = { parts: ['PATRONYMIC'] };

export const NAMES = {
  /** Имя */
  FIRSTNAME: 'firstname',
  /** Фамилия */
  LASTNAME: 'lastname',
  /** Отчество */
  PATRONYMIC: 'patronymic',
};

export const FULL_NAME_SEQUENCE = [NAMES.LASTNAME, NAMES.FIRSTNAME, NAMES.PATRONYMIC];

export const DEFAULT_VALUES = Object.values(NAMES).reduce((acc, key) => {
  return { ...acc, [key]: '' };
}, {});
